import React from "react";

export default function Contact() {
  const html = `<div class="row row-cols-1 row-cols-sm-2 row-cols-md-2 g-2">
<div class="col">
<div class="card shadow-sm">
<h5>Contact us</h5>
<img alt="" height='250px"' src="/img/i12.jpg"/>
</div>
</div>
<div class="col">
<div class="card shadow-sm">
<div class="card-body">
<p class="card-text"> <span class="style8">Shri Ghanamatheshwar College of Education (B.Ed.)</span><br/>
<b>Address -</b> Minajagi Cross, Talikoti-586214<br/>
<b>Phone -</b> 7259552699<br/>
<b>Email -</b> besttalikoti@gmail.com
</p>
</div>
</div>
</div>
</div>`;
  return (
    <div className="container my-4">
      <div dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
}
